import {
  EMPTY, EMAIL, PASSWORD_LENGTH, PASSWORD_LETTER, PASSWORD_NUMBER, PASSWORD_MATCH,
  MESSAGES,
  PASSWORD_SPECIAL_CHARACTER,
  RULES,
  PERSONAL_INFORMATION_FIRST_NAME,
  PERSONAL_INFORMATION_LAST_NAME
} from 'helpers/validator/constants'
import getValidator from 'helpers/validator/validator'
import {
  EMAIL_EMPTY,
  EMAIL_INVALID,
  PASSWORD_EMPTY,
  TERMS_AGREEMENT_UNSELECTED,
  FIRST_NAME_EMPTY,
  LAST_NAME_EMPTY,
  PHONE_NUMBER_EMPTY,
  INVALID_FIRST_NAME,
  INVALID_LAST_NAME
} from './constants'
import { passwordDecorator, passwordAndConfPassDecorator } from './helpers'
import form from './form'

export default getValidator({
  [form.firstName.name]: [
    { type: EMPTY, message: FIRST_NAME_EMPTY },
    { type: PERSONAL_INFORMATION_FIRST_NAME, message: INVALID_FIRST_NAME }
  ],
  [form.lastName.name]: [
    { type: EMPTY, message: LAST_NAME_EMPTY },
    { type: PERSONAL_INFORMATION_LAST_NAME, message: INVALID_LAST_NAME }
  ],
  [form.primaryPhone.name]: [
    { type: EMPTY, message: PHONE_NUMBER_EMPTY }
  ],
  [form.email.name]: [
    { type: EMAIL, message: EMAIL_INVALID },
    { type: EMPTY, message: EMAIL_EMPTY }
  ],
  [form.password.name]: {
    type: EMPTY, message: PASSWORD_EMPTY
  },
  [form.confirmPassword.name]: {
    type: EMPTY, message: PASSWORD_EMPTY
  },
  [form.termsAgreement.name]: {
    type: EMPTY, message: TERMS_AGREEMENT_UNSELECTED
  },
  [form.hiddenField.name]: [
    { type: PASSWORD_LENGTH },
    { type: PASSWORD_LETTER },
    { type: PASSWORD_NUMBER },
    { type: PASSWORD_SPECIAL_CHARACTER },
    { type: PASSWORD_MATCH, passValues: true, decorate: true, checkValidity: passwordAndConfPassDecorator }
  ]
})

export const rules = [
  { label: MESSAGES[PASSWORD_LENGTH], checkValidity: passwordDecorator(RULES[PASSWORD_LENGTH]) },
  { label: MESSAGES[PASSWORD_LETTER], checkValidity: passwordDecorator(RULES[PASSWORD_LETTER]) },
  { label: MESSAGES[PASSWORD_NUMBER], checkValidity: passwordDecorator(RULES[PASSWORD_NUMBER]) },
  { label: MESSAGES[PASSWORD_SPECIAL_CHARACTER], checkValidity: passwordDecorator(RULES[PASSWORD_SPECIAL_CHARACTER]) },
  { label: MESSAGES[PASSWORD_MATCH], checkValidity: passwordAndConfPassDecorator(RULES[PASSWORD_MATCH]) }
]
